<template>
  <div class="flex flex-col justify-center gap-2 m-4">
    <chip
      v-for="prompt in topList"
      :key="prompt.id"
      :text="prompt.text"
      :disabled="disabled"
      @click="$emit('ask', prompt.text)"
    />
    <el-button
      type="primary"
      link
      class="ml-0"
      data-testid="ai-chat-prompts-view-all-button"
      @click="$emit('view-all')"
      >{{ $t('aichat.main.chips.button.view_all') }}</el-button
    >
  </div>
</template>

<script>
import Chip from './chip'

import prompts from '../../constants/prompts'

export default {
  components: {
    Chip
  },
  props: {
    /* the chat cannot take a question: the chips are disabled, "View all" still opens the list */
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['view-all', 'ask'],
  setup() {
    const { topList } = prompts.setup()

    return {
      topList
    }
  }
}
</script>
